import { render, staticRenderFns } from "./TeamView.vue?vue&type=template&id=d72bb9f2"
import script from "./TeamView.vue?vue&type=script&lang=js"
export * from "./TeamView.vue?vue&type=script&lang=js"
import style0 from "./TeamView.vue?vue&type=style&index=0&id=d72bb9f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports